module.exports = __webpack_public_path__ + "5dbde1ae3939eb481e2fa9d33636aa8a.pdf";